module.exports = __webpack_public_path__ + "media/components/riskregister/icons/equipment-d75269670b0f2cf8d9be214a591d1021.png";